import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
// import { Link } from 'react-router-dom';
// import ReactDOM from 'react-dom';

// redux
import { closeMenu } from 'store'
import { useDispatch } from 'react-redux';

// component
import Header from 'component/Header';
import SubHeader from 'component/SubHeader';
import Menu from 'component/Menu';
import Footer from 'component/Footer';
// import Modal from 'component/Modal';

// function
import MoveWithMarketo from 'function/MoveWithMarketo';

import './PageNew.scss';

// json
import newProducts from 'json/newProducts';

type Props = {
  testPath: string,
}

const PageNew: React.FC<Props> = (props) => {

  // dispatch
  const dispatch = useDispatch();

  // history
  const history = useHistory();

  // 変数
  // let currentFloor = 0;
  // let currentArea = 0;
  // let currentSlide = 0;
  // let currentModal = 0;
  // let currentAreaObj: areaType ={
  //   title: "",
  //   lead: "",
  //   slides: [
  //     {
  //       text: '',
  //       modals: [
  //         {
  //           x: 40, y: 40, title: "", lead1: "", lead2: "",
  //           url: "",
  //         }
  //       ]
  //     }
  //   ]
  // };

  // useState
  const [isFloor3Active, setIsFloor3Active] = useState(true);
  const [isFloor4Active, setIsFloor4Active] = useState(true);
  // const [isModal, setIsModal] = useState(false);

  // Effect
  useEffect(() => {
    // タイトルなど
    // document.title = 'NEW PRODUCTS';

    // ページ遷移時にメニューを閉じる
    return () => {
      dispatch(closeMenu());
    }
  });

  // handle
  const handleClickAllList = (e:React.MouseEvent<HTMLAnchorElement, MouseEvent>, floor:number) => {
    e.preventDefault();
    if(floor === 3){
      setIsFloor3Active(!isFloor3Active);
    }else{
      setIsFloor4Active(!isFloor4Active);
    }
  }

  const handleClickProduct = (e:React.MouseEvent<HTMLAnchorElement, MouseEvent>, floor:number, isModal:boolean, isNew:boolean, url:string) => {
    e.preventDefault();

    let isCurrentFloorActive: boolean = false;
    if( floor===0 && isFloor3Active){
      isCurrentFloorActive = true;
    }
    if( floor===1 && isFloor4Active){
      isCurrentFloorActive = true;
    }

    // 現在のフロアがアクティブ、または新商品なら遷移処理をする
    if(isCurrentFloorActive || isNew){

      // 遷移処理
      MoveWithMarketo(e,history);
    }
  }

  // const handleOpenModal = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>)=>{
  //   e.preventDefault();
  //   // setIsModal(true);

  //   // モーダルの読み込み
  //   ReactDOM.render(
  //     <Modal
  //       testPath={props.testPath}
  //       currentFloor={currentFloor}
  //       currentArea={currentArea}
  //       activeSlide={currentSlide}
  //       activeModal={currentModal}
  //       currentAreaObj={currentAreaObj}
  //       handleCloseModal={handleCloseModal}
  //     />,
  //     document.getElementById('modalWrapper')
  //   );
  // }

  // const handleCloseModal = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>)=>{
  //   e.preventDefault();
  //   // setIsModal(false);

  //   // モーダルの削除
  //   ReactDOM.render(
  //     <div></div>,
  //     document.getElementById('modalWrapper')
  //   );
  // }

  return (
    <div id="PageNew">
      <Header />
      <Menu />
      <SubHeader active={3} />
      <div className="topTitle">
        <h2 className="c-h2">展示商品を確認する</h2>
      </div>

      <section id="floor3" className={isFloor3Active ? 'active' : ''}>
        <h3>
          <p className="title"><span>3F</span></p>
          <ul>
            {isFloor3Active ?
              <li><a href="/" className="iconAll onlyNew" onClick={(e)=>{handleClickAllList(e,3);}}>新製品で絞り込む</a></li>
              :
              <li><a href="/" className="iconAll" onClick={(e)=>{handleClickAllList(e,3);}}>全商品を表示する</a></li>
            }

          </ul>
        </h3>
        <div className="list">
          <ul>
            {/* 3Fループ ここから */}
            { newProducts[1].products.map((p,i)=>{
              return(
                <li key={i} className={p.isNew ? 'check' : ''}>
                  <a href={p.url} onClick={(e)=>{handleClickProduct(e,0,p.isModal,p.isNew,p.url)}}>
                    <div className="img"><img src={`${props.testPath}${p.imgSrc}`} alt="" /></div>
                    <div className="txtGroup">
                      <p className="productName">{p.name}</p>
                      { p.genre !=='' &&
                        <p className="genre">{p.genre}</p>
                      }
                    </div>
                  </a>
                </li>
              )
            })}
            {/* 3Fループ ここまで */}
            <li className="blank"></li>
            <li className="blank"></li>
            <li className="blank"></li>
          </ul>
        </div>
      </section>

      <section id="floor4" className={isFloor4Active ? 'active' : ''}>
        <h3>
          <p className="title"><span>4F</span></p>
          <ul>
            {isFloor4Active ?
              <li><a href="/" className="iconAll onlyNew" onClick={(e)=>{handleClickAllList(e,4);}}>新製品で絞り込む</a></li>
              :
              <li><a href="/" className="iconAll" onClick={(e)=>{handleClickAllList(e,4);}}>全商品を表示する</a></li>
            }
          </ul>
        </h3>
        <div className="list">
          <ul>
            {/* 4Fループ ここから */}
            { newProducts[0].products.map((p,i)=>{
              return(
                <li key={i} className={p.isNew ? 'check' : ''}>
                  <a href={p.url} onClick={(e)=>{handleClickProduct(e,1,p.isModal,p.isNew,p.url)}}>
                    <div className="img"><img src={`${props.testPath}${p.imgSrc}`} alt="" /></div>
                    <div className="txtGroup">
                      <p className="productName">{p.name}</p>
                      { p.genre !=='' &&
                        <p className="genre">{p.genre}</p>
                      }
                    </div>
                  </a>
                </li>
              )
            })}
            {/* 4Fループ ここまで */}
            <li className="blank"></li>
            <li className="blank"></li>
            <li className="blank"></li>
          </ul>
        </div>
      </section>
      <div id="modalWrapper"></div>
      {/* { isModal &&
        <Modal
          testPath={props.testPath}
          currentFloor={currentFloor}
          currentArea={currentArea}
          activeSlide={currentSlide}
          activeModal={currentModal}
          currentAreaObj={currentAreaObj}
          handleCloseModal={handleCloseModal}
        />
      } */}
      <Footer />
    </div>
  );
}

export default PageNew;
